"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { MoreHorizontalIcon } from "../../icons/index.js";
import makeStyles from "../../theming/make-styles.js";
import { IconButton } from "../button/index.js";
import Dropdown, { DropdownItem } from "../dropdown/index.js";
import Tooltip from "../tooltip/index.js";
import getColorComponent from "../utils/get-color-component.js";
export function TableRowAction(_props) {
    return null;
}
const useStyles = makeStyles()((theme, { gap, renderDropdown }) => ({
    buttons: {
        display: "none",
        columnGap: theme.spacing(gap),
        [theme.breakpoints.up("xl")]: {
            display: renderDropdown ? "none" : "inline-flex",
        },
    },
    menuButton: {
        display: "inline-flex",
        [theme.breakpoints.up("xl")]: {
            display: renderDropdown ? "inline-flex" : "none",
        },
    },
}));
export function TableRowActions(_a) {
    var _b;
    var { color, children, gap = "sm" } = _a, props = __rest(_a, ["color", "children", "gap"]);
    const { classes } = useStyles({ gap, renderDropdown: ((_b = React.Children.count(children)) !== null && _b !== void 0 ? _b : 0) > 3 });
    const onClicks = useMemo(() => React.Children.map(children, (child) => (e) => {
        var _a, _b;
        e.stopPropagation();
        e.bubbles = true;
        e.currentTarget.blur();
        !!child && ((_b = (_a = child.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, Object.assign({ value: child.props.value }, child.props.metadata), e));
    }), [children]);
    if (!React.Children.count(children)) {
        return null;
    }
    const triggerElement = _jsx(IconButton, { className: classes.menuButton, icon: MoreHorizontalIcon, round: true, size: "small", variant: "faded" });
    const buttons = React.Children.map(children, (child, key) => {
        var _a;
        return !!child && (_jsx(Tooltip, { triggerElement: _jsx(IconButton, { color: getColorComponent((_a = child.props.color) !== null && _a !== void 0 ? _a : color), "data-testid": child.props["data-testid"], disabled: child.props.disabled, icon: child.props.icon, round: true, size: "small", variant: "faded", onClick: onClicks === null || onClicks === void 0 ? void 0 : onClicks[key] }), children: child.props.children }, key));
    });
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: classes.buttons, children: buttons }), _jsx(Dropdown, Object.assign({ strategy: "align-right", triggerElement: triggerElement }, props, { children: React.Children.map(children, (child, key) => !!child && (_jsx(DropdownItem, { "data-testid": child.props["data-testid"], disabled: child.props.disabled, leftIcon: child.props.icon, value: child.props.value, onClick: onClicks === null || onClicks === void 0 ? void 0 : onClicks[key], children: child.props.children }, key))) }))] }));
}
export default TableRowActions;
//# sourceMappingURL=table-row-actions.js.map